module.exports = __webpack_public_path__ + "img/14.c19934e8.jpeg";